module.exports = __webpack_public_path__ + "img/game1.fd6b2214.png";